import * as PIXI from 'pixi.js';
import { IHexPixelSize } from 'js/bubbleCore/view/types';

export function spacePositionToPxPosition(
  spaceX: number,
  spaceY: number,
  {size, width, height}: IHexPixelSize,
  out?: PIXI.Point,
): PIXI.Point {
  const result = out || new PIXI.Point();
  result.set(
    spaceX * size + width * 0.5, 
    spaceY * size + height * 0.5,
  );
  return result;
}
